import { useState } from "react";
import { Link } from "react-router-dom";
import {
  KeyRound, Layers, Sailboat, ShoppingBasket,
  Dumbbell, Hand, Scissors, Car, ChefHat, Baby,
} from "lucide-react";
import { useLang } from "@/i18n";
import Reveal from "@/components/Reveal";

export const SERVICE_ICONS = {
  gardiennage: KeyRound,
  linge: Layers,
  bateau: Sailboat,
  courses: ShoppingBasket,
};

export const PROVIDER_ICONS = {
  coach: Dumbbell,
  masseuse: Hand,
  coiffeur: Scissors,
  chauffeur: Car,
  cuisinier: ChefHat,
  babysitter: Baby,
};

function SelectableGrid({ keys, icons, images, dict, basePath, testidPrefix, moreLabel }) {
  const [selected, setSelected] = useState(keys[0]);
  return (
    <div>
      <div className={`grid gap-4 sm:gap-5 ${keys.length > 4 ? "grid-cols-2 md:grid-cols-3 lg:grid-cols-6" : "grid-cols-2 md:grid-cols-4"}`}>
        {keys.map((key) => {
          const Icon = icons[key];
          const active = key === selected;
          return (
            <button
              key={key}
              onClick={() => setSelected(key)}
              data-testid={`${testidPrefix}-${key}`}
              className={`flex flex-col items-center justify-center gap-4 rounded-2xl border px-3 py-8 text-center transition-all duration-300 ${
                active
                  ? "border-maquis-olive bg-ivoire shadow-[0_18px_40px_-24px_rgba(42,51,35,0.45)]"
                  : "border-maquis-deep/10 bg-casse hover:border-maquis-olive/50 hover:bg-ivoire"
              }`}
            >
              <Icon size={36} strokeWidth={0.9} className={active ? "text-maquis-deep" : "text-maquis-olive"} />
              <span className="text-[11px] sm:text-xs uppercase tracking-[0.14em] text-maquis-deep/85">
                {dict[key].title}
              </span>
            </button>
          );
        })}
      </div>

      <Reveal key={selected} className="mt-10">
        <div
          data-testid={`${testidPrefix}-detail`}
          className="grid items-center gap-0 overflow-hidden rounded-2xl border border-maquis-deep/10 bg-ivoire/70 md:grid-cols-2"
        >
          <img
            src={images[selected]}
            alt={dict[selected].title}
            loading="lazy"
            className="h-64 w-full object-cover md:h-80"
          />
          <div className="p-8 md:p-10">
            <h3 className="font-serif text-2xl sm:text-3xl text-maquis-deep">{dict[selected].title}</h3>
            <p className="mt-4 text-sm sm:text-base leading-relaxed text-maquis-olive">{dict[selected].desc}</p>
            <Link
              to={`${basePath}#${selected}`}
              data-testid={`${testidPrefix}-more-${selected}`}
              className="mt-6 inline-block border-b border-maquis-deep/30 pb-1 text-xs uppercase tracking-[0.2em] text-maquis-deep transition-colors duration-300 hover:border-maquis-deep"
            >
              {moreLabel}
            </Link>
          </div>
        </div>
      </Reveal>
    </div>
  );
}

export function ServicesGrid() {
  const { t, simg } = useLang();
  const images = {
    gardiennage: simg("door"),
    linge: simg("linen"),
    bateau: simg("boat"),
    courses: simg("groceries"),
  };
  return (
    <SelectableGrid
      keys={Object.keys(SERVICE_ICONS)}
      icons={SERVICE_ICONS}
      images={images}
      dict={t.services.items}
      basePath="/services"
      testidPrefix="service-icon"
      moreLabel={t.services.more}
    />
  );
}

export function ProvidersGrid() {
  const { t, simg } = useLang();
  const images = {
    coach: simg("coach"),
    masseuse: simg("spa"),
    coiffeur: simg("coiffeur"),
    chauffeur: simg("chauffeur"),
    cuisinier: simg("chefPlating"),
    babysitter: simg("babysitter"),
  };
  return (
    <SelectableGrid
      keys={Object.keys(PROVIDER_ICONS)}
      icons={PROVIDER_ICONS}
      images={images}
      dict={t.providers.items}
      basePath="/prestataires"
      testidPrefix="provider-icon"
      moreLabel={t.providers.more}
    />
  );
}
